<template lang="html">
  <UTabs
    :items="tabItems"
    :content="false"
    :model-value="modelValue"
    color="tertiary"
    variant="pill"
    class="auth-login-type-tabs w-full"
    :ui="{ list: 'w-full' }"
    @update:model-value="emit('update:modelValue', $event as LoginInputType)"
  />
</template>

<script setup lang="ts">
import type { TabsItem } from '@nuxt/ui'

import { LoginInputType } from './type'

import { LOGIN_TYPE_TAB_LABELS } from '#Auth/support/loginType'

const props = defineProps<{
  modelValue: LoginInputType
  allowedTypes: LoginInputType[]
}>()

const emit = defineEmits<{
  'update:modelValue': [value: LoginInputType]
}>()

const tabItems = computed<TabsItem[]>(() =>
  props.allowedTypes.map(type => ({
    label: LOGIN_TYPE_TAB_LABELS[type],
    value: type,
  })),
)
</script>
